module.exports = __webpack_public_path__ + "img/loans.27c59c6.webp";